import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { ToolFilterOption } from "src/app/models/Filters/ToolFilterOption";
import { ColumnFilter } from "src/app/models/ToolFilter";

import { ToolFilterCategory } from "./../../models/Filters/ToolFilterCategory";

@Component({
  selector: "filter-category",
  templateUrl: "./filter-category.component.html",
  styleUrls: ["./filter-category.component.scss"],
  standalone: false,
})
export class FilterCategoryComponent {
  private _category: ToolFilterCategory;

  @Input()
  set category(v: ToolFilterCategory) {
    this._category = v;
    this.filteredOptions = v.options.slice();
    this.onSearchChange();
    this.checkSelected();
  }
  get category(): ToolFilterCategory {
    return this._category;
  }

  @Input() limitTo: number = 5;
  @Output() categoryChange: EventEmitter<ColumnFilter> = new EventEmitter<ColumnFilter>();

  search: string;
  filteredOptions: ToolFilterOption[] = [];
  anySelected: boolean = false;

  constructor(
    private translate: TranslateService,
    private cd: ChangeDetectorRef,
  ) {}

  onSearchChange() {
    if (!this.search) {
      this.filteredOptions = this.category.options;
      return;
    }

    this.filteredOptions = this.category.options.filter((option) => {
      const searched = option.key
        ? option.title
          ? option.title
          : option.key
        : this.translate.instant("toolfilters.none");
      return searched.toLowerCase().includes(this.search?.toLowerCase());
    });
  }

  onColumnFilterChange() {
    const values = this.category.options.filter((x) => x.selected).map((x) => x.key);
    const categoryFilter: ColumnFilter = new ColumnFilter(this.category.id);
    categoryFilter.values = values;
    this.categoryChange.emit(categoryFilter);
    this.checkSelected();
  }

  checkSelected() {
    this.anySelected = this.category?.options?.some((a) => a.selected);

    // change detection here is called in setTimeout, because otherwise
    // mat-checkbox - selections are not correctly propagated in the UI and
    // all checkboxes - shown as not selected, even though we have already some selected options.
    setTimeout(() => this.cd.detectChanges());
  }
}
